import React from "react";
import { useDispatch, useSelector } from "react-redux";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { actionCreators } from "../redux/staffGrossSalesSaga";

export const Dropdown = ({
  keyName,
  label,
  isMultiSelect = true,
  width = "160px",
  ...restProps
}) => {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.staffGrossSales.filters[keyName]);
  const selectedOption = useSelector((state) => state.staffGrossSales.selectedFilters[keyName]);

  if (!Array.isArray(options) || !options.length) return null;

  const onSelectChange = (data) => {
    dispatch(actionCreators.updateFilter({ data, key: keyName }));
  };

  return (
    <div className="select-box" style={{ width }}>
      <p className="offers-title">{label}</p>
      <MultiSelectDropdown
        options={options}
        selectedFilters={selectedOption}
        placeholder="Not selected"
        height={324}
        onSelectChange={onSelectChange}
        {...(isMultiSelect
          ? { numberDisplayed: 0, includeSelectAll: true, enableOnly: true, includeFilter: true }
          : { includeFilter: false }
        )}
        {...restProps}
      />
    </div>
  );
};
